"use client";

import type { BlogSourceEntry } from "@/utils/blog";

interface SourcesProps {
  sources: BlogSourceEntry[] | undefined;
  label: string;
}

export default function Sources({ sources, label }: Readonly<SourcesProps>) {
  if (!sources?.length) return null;

  return (
    <nav aria-label={label} className="not-prose w-full min-w-0">
      <div className="rounded-2xl border border-black/10 bg-white p-6">
        <p className="mb-3 text-xs uppercase tracking-wide font-monument font-medium text-gail-gray">
          {label}
        </p>
        <div>
          <ol className="flex list-none flex-col gap-2 pl-0">
            {sources.map((source, i) => {
              const num = i + 1;
              const inner = (
                <span className="flex items-start gap-2 text-left">
                  <span className="shrink-0 text-xs font-semibold leading-snug font-monument text-gail-gray">
                    {num}.
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block text-sm font-semibold leading-snug font-monument font-medium text-black">
                      {source.title}
                    </span>
                    {source.description ? (
                      <span className="mt-0.5 block text-xs font-monument text-gail-gray">
                        {source.description}
                      </span>
                    ) : null}
                    {source.date ? (
                      <span className="mt-0.5 block text-xs font-monument text-gail-gray">
                        {source.date}
                      </span>
                    ) : null}
                  </span>
                </span>
              );
              return (
                <li key={num} id={`source-${num}`}>
                  {source.url ? (
                    <a
                      href={source.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block -mx-1.5 rounded-md px-1.5 py-1 transition-colors hover:bg-black/5"
                    >
                      {inner}
                    </a>
                  ) : (
                    <span className="block -mx-1.5 px-1.5 py-1">{inner}</span>
                  )}
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </nav>
  );
}
